import {
    defaultColumnsVisibility,
    defaultColumnsSizing,
    paramColumnToColumnKey,
    defaultColumnsOrder,
} from '@/store/well-logs/tabletSettings/config';
import { safeJsonParse } from '@/store/well-logs/profiles/libs/prepareProfileWellColumns';
/*
    Сброс видимости колонок в значение false
*/
const resetColumnsVisibility = columns => {
    const columnKeys = Object.keys(columns);
    const result = {};

    for (const columnKey of columnKeys) {
        result[columnKey] = false;
    }

    return result;
};

const getColumnsOrder = columnsOrder => {
    if (columnsOrder) {
        const restColumns = defaultColumnsOrder.filter(key => !columnsOrder.find(tKey => tKey === key));
        return [...columnsOrder, ...restColumns];
    }
    return defaultColumnsOrder;
};
const rigisColumnsArray = ['geoObjects', 'lithology', 'thicknessInterlayer', 'paramsHistogram'];

/*
    Формирование части настроек (видимость и размер) планшета согласно значения из сущности "Состояние скважины"
*/
export const getSettingsFromWellProfile = (stateWell, defaultSettings, rootState) => {
    const { inspector, tablets } = rootState;
    let geoVersions,
        rigisColumnsOrder,
        rigisParamsHistogramIds,
        fgiParamsHistogramIds,
        parsedColumnsOrder = [];
    let rigisColumnsCount = 3;

    const { params: stateWellParams } = stateWell;
    const visibility = resetColumnsVisibility(defaultColumnsVisibility);
    const sizes = { ...defaultColumnsSizing };
    const geoObjecstStrParamValue = stateWellParams.filter(param => param.paramTitle === 'Пласт')[0]?.strParamValue;
    if (geoObjecstStrParamValue) {
        parsedColumnsOrder = geoObjecstStrParamValue ? safeJsonParse(geoObjecstStrParamValue)?.columnsOrder : [];

        for (const param of stateWellParams) {
            const columnKey = paramColumnToColumnKey[param.paramColumn];

            const { paramWidth, intParamValue, paramType, strParamValue } = param;

            if (!columnKey) continue;

            if (columnKey === 'geoObjects' && strParamValue) {
                const parsedSettings = JSON.parse(strParamValue);
                visibility[columnKey] = parsedSettings.visible === '1' ? true : false; //предварительно сохранённые параметры видимости колонок
                geoVersions = parsedSettings.versions;
                rigisColumnsCount = parsedSettings.rigisColumnsCount ?? defaultSettings.rigisColumnsCount;
                rigisColumnsOrder = parsedSettings.rigisColumnsOrder ?? defaultSettings.rigisColumnsOrder;
                rigisParamsHistogramIds =
                    parsedSettings.rigisParamsHistogramIds ?? defaultSettings.rigisParamsHistogramIds;
                fgiParamsHistogramIds = parsedSettings.fgiParamsHistogramIds ?? defaultSettings.fgiParamsHistogramIds;
            }
            if (columnKey === 'carrotage') {
                visibility[columnKey] = intParamValue && intParamValue === 2 ? true : false; //предварительно сохранённые параметры видимости колонок
            }
            if (columnKey !== 'carrotage' && columnKey !== 'geoObjects')
                visibility[columnKey] = strParamValue && strParamValue === '1' ? true : false; //предварительно сохранённые параметры видимости колонок
            if (columnKey) {
                const { minWidth } = sizes[columnKey];
                sizes[columnKey] = {
                    ...sizes[columnKey],
                    width: Math.max(minWidth, paramWidth),
                    widthType: 'PIXEL',
                };
            }
        }
    } else {
        rigisColumnsCount = 0;
        parsedColumnsOrder = defaultColumnsOrder;
        let insertedAllGeoObjects = false;
        if (inspector.geoObjects[tablets.activeGroupName]?.length > 0) {
            geoVersions = inspector.geoObjects[tablets.activeGroupName].map(item => ({
                id: item.stratumVersionId,
                visible: item.visible,
            }));
        }
        for (const param of stateWellParams) {
            let columnKey = paramColumnToColumnKey[param.paramColumn];
            if (param.paramColumn === 4) columnKey = 'lithology'; // Раньше колонка Литология/Насыщение имела занчение 4, сейчас 3.

            if (!columnKey) continue;

            if (!insertedAllGeoObjects && rigisColumnsArray.includes(columnKey)) {
                let geoIndex = parsedColumnsOrder.indexOf(columnKey);
                const allGeoIndex = parsedColumnsOrder.indexOf('allGeoObjects');

                if (geoIndex !== -1) {
                    if (allGeoIndex !== -1) {
                        parsedColumnsOrder.splice(allGeoIndex, 1);

                        if (allGeoIndex < geoIndex) {
                            geoIndex--;
                        }
                    }

                    parsedColumnsOrder.splice(geoIndex, 0, 'allGeoObjects');
                    insertedAllGeoObjects = true;
                }
            }

            if (
                columnKey === 'geoObjects' ||
                columnKey === 'lithology' ||
                columnKey === 'thicknessInterlayer' ||
                columnKey === 'paramsHistogram'
            ) {
                visibility.allGeoObjects = true;
                rigisColumnsCount++;
            }
            visibility[columnKey] = true;

            {
                const { paramWidth } = param;
                const { minWidth } = sizes[columnKey];

                sizes[columnKey] = {
                    ...sizes[columnKey],
                    width: Math.max(minWidth, paramWidth),
                    widthType: 'PIXEL',
                };
            }
        }
    }

    return {
        columnsOrder: getColumnsOrder(parsedColumnsOrder),
        geoVersions: geoVersions,
        columnsVisibility: visibility,
        columnsSizing: sizes,
        fgiParamsHistogramIds: fgiParamsHistogramIds,
        rigisParamsHistogramIds: rigisParamsHistogramIds,
        rigisColumnsCount: rigisColumnsCount,
        rigisColumnsOrder: rigisColumnsOrder ?? defaultSettings.rigisColumnsOrder,
    };
};
